<template>
  <!-- 隐私声明更新提示弹窗 -->
  <message-box ref="protocolMsgBoxRef" confirmButtonText="立即查看" cancelButtonText="取消并退出" :showCancelButton="true"
    :closeOnClickModal="false" confirmButtonClasses="confirm-btn" cancelButtonClasses="cancel-btn"
    messageContentClass="protocol-box-content" contentClasses="protocol-content" title='隐私声明更新通知'
    message="尊敬的用户您好，EMS中国邮政速递物流的隐私声明内容有更新，请查看更新后的隐私内容" @confirm="confirmProtocol"
    @cancel="cancelProtocol"></message-box>
</template>

<script>
import messageBox from '@/components/messageBox/index.vue'

export default {
  components: {
    messageBox
  },
  data () {
    return {

    }
  },
  mounted () {
    this.$refs.protocolMsgBoxRef && (this.$refs.protocolMsgBoxRef.showMsgBox())
  },
  methods: {
    confirmProtocol () {
      this.$store.commit('protocol/setShowContent', true)
    },
    cancelProtocol () {
      this.$store.commit('protocol/setShowContent', false)
      this.$store.commit('protocol/setShowNotice', false)
    }
  }
}

</script>
<style lang="scss">
@media screen and (min-width: 478px) {
  #app .message-box .message-content {
    width: auto !important;
    min-width: auto !important;
  }
}

.protocol-box-content {
  .protocol-content {
    padding: 20px !important;
  }

  .btn-group {
    display: flex;
    height: 44px;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #eee;
    margin-bottom: 0 !important;
  }

  .cancel-btn,
  .confirm-btn {
    height: 44px !important;
    flex: 1;
    border: none !important;
    background-color: transparent !important;
    font-size: 16px !important;
  }

  .confirm-btn {
    color: #ffa425 !important;
  }

  .cancel-btn {
    position: relative;

    &::after {
      position: absolute;
      top: 0;
      right: 0;
      width: 1px;
      height: 44px;
      border-right: 1px solid #eee;
      content: "";
      transform: scaleX(0.5);
    }
  }
}
</style>
